abstract class CreateAnnouncementService {
  public abstract addAnnouncement(data: any): Promise<App.Response<void>>;
}
export default CreateAnnouncementService;
